<div class="background quick-fadey">
<router-outlet></router-outlet>
</div>
